import { FlexBox } from "@brg/ui";
import { useBreakpoint, useIsMobile } from "@brg/ui";
import { SlideNavigation } from "shared/components/slideNavigation";
import { useCallback, useMemo } from "react";
import { LayoutConst } from "core/modules/layout.module";
import { SlideNavigationWrapperItemCustomLink } from "shared/pages/explore/styles";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { bProfile } from "core/utils/bProfile";
import { useProfile } from "@brg/auth";
import useQueryState from "shared/hooks/useQueryState";
import { AppTester } from "supporting";
import { useEncodedStateFilter } from "shared/components/Filters";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { DropdownTabs } from "./DropdownTabs";
import { TeamTabsWrapper } from "./styles";

const TeamTabs = ({
    team,
    tabList,
    tabColors,
    setCurrentTab,
    currentTab,
    contextTabs,
    tabIndex,
    titleIsTabs,
    isLoading,
    isContextWithoutTabs,
}: any) => {
    const {
        contextName: context,
        teamId,
        isShowEmployeesLink: contextHasEmployees,
        shouldVisibleMobileTabsOrTeamLink,
        isShopVisible,
        categories
    } = team;
    const profile = useProfile()
    const history = useHistory();
    const { t, i18n: { language } } = useTranslation();
    const theme = useTheme();
    const is992 = useBreakpoint(992);
    const is743 = useBreakpoint(743);
    const isMobile = useIsMobile();
    const [_, setQueryParams] = useQueryState();
    const { setSorting } = useEncodedStateFilter()

    const hasCategories = !!categories?.length;

    const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);

    const isMedia = AppTester.isMediiia() && !AppTester.isLectureMediiia();
    const isExam = AppTester.isExamHSE();
    const isLMSHSE = AppTester.isLMSHSE();
        const isHSEDesign = AppTester.isHSEDesign();
    const isCreativeCityUnit = useMemo(() => context === 'creativecityacademy', [context])

    const isGeograffee = AppTester.isGeograffee();
    const isDafes = AppTester.isGeoDafes();
    const isGameDeziiign = AppTester.isGameDeziiign();
    const isSuperPuper = AppTester.isSuperPuper();
    const isCGRAVE = AppTester.isCGRAVE();
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const isContiniumSite = AppTester.isContinuumSite();
    const isAcademy = AppTester.isAcademy();

    const isSuperPuperGames = useMemo(
        () => ((context  === 'superpupergames-mediiia'))
        , [context]);
    const shouldDisplayShopLink = useMemo(() => (isShopVisible), [isShopVisible, isModer]);
    const shouldShowDropdownTabs = isSuperPuperGames ? is743 : is992;

    const onShopClick = useCallback(() => {
        history.push(`/teams/${context || teamId}/shop`)
        return;
    }, [context])

    const shopLink = useMemo(() => shouldDisplayShopLink && (
        <SlideNavigationWrapperItemCustomLink
            style={{ marginLeft: (Object.keys(tabList).length > 0) ? 32 : 0, marginBottom: "0px" }}
            onClick={onShopClick}
            white_theme={false}
            active={false}>
            {t('nav.shop')}
            <svg
                className={'shop-link-svg'}
                width='16'
                height='14'
                viewBox='0 0 16 14'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    fill={theme.designerPage.slideLineInActive}
                    d='M12 10.7149H10.3329L10.3431 6.86984L5.21474 12L4 10.786L9.12833 5.65587H5.27573L5.2859 4H12V10.7149Z'
                />
            </svg>
        </SlideNavigationWrapperItemCustomLink>), [shouldDisplayShopLink, onShopClick, language, tabList, contextHasEmployees, shouldVisibleMobileTabsOrTeamLink])


    const tabsVisible = (
        (!isContextWithoutTabs && !(titleIsTabs && !hasCategories)) || shouldDisplayShopLink
    )
  
    if (shouldShowDropdownTabs) {
        return (
            <TeamTabsWrapper alignMobile='center' align={'center'} justify='flex-start' justifyMobile='flex-start' widthMobile={'100%'} width={'100%'}>
                {!isContextWithoutTabs && <DropdownTabs
                    //todo [МУСОР] брать из темы
                    whiteTheme={(isGeograffee && !isDafes || isGameDeziiign) || isSuperPuper || isCGRAVE || isAdcrDafesNet || isContiniumSite}
                    activeTabKey={currentTab}
                    // hasEmployees={contextHasEmployees}
                    // onTeamClick={onTeamClick}
                    displayShop={shouldDisplayShopLink}
                    onShopClick={shouldDisplayShopLink ? onShopClick : undefined}
                    mobileShrink={true}
                    activeText={(isAcademy || isSuperPuper) ? false : true}
                    isSuperPuperGames={isSuperPuperGames}
                    items={tabList}
                    onChange={(tab) => {
                        setCurrentTab(tab as string);
                        setQueryParams({ /*page: 1,*/ tab }, { replace: true });
                        sessionStorage.setItem('lastTab', tab)
                    }}
                />}
                {isContextWithoutTabs && shouldDisplayShopLink && shopLink}
            </TeamTabsWrapper>
        )
    }

    if (!tabsVisible) {
        return null;
    }

    return (
        <TeamTabsWrapper style={{ placeItems: 'center', position: 'relative' }} direction='row' className={'slide-navigation'}>
            {!isContextWithoutTabs && (
                <SlideNavigation
                    autoWidth={contextHasEmployees}
                    activeIndexKey={currentTab}
                    onChange={(tab) => {
                        if (isMedia) {
                            switch (tab) {
                                case 'popular':
                                    setSorting(2)
                                    break
                                case 'new':
                                    setSorting(1)
                                    break
                            }
                        }
                        setCurrentTab(tab as string);
                        // setQueryParams({ /*page: 1,*/ tab }, { replace: true });
                        sessionStorage.setItem('lastTab', tab)
                    }}
                    items={tabList}
                    colors={tabColors}
                    isLoading={isLoading}
                    capitalize={false}
                    // blueSelect={isMedia}
                    hoverPopup={!isMobile}
                    hoverContent={tabIndex}
                    hoverDataName={contextTabs}
                    isSuperPuperGames={isSuperPuperGames}
                    dropdownWhiteTheme={isExam || isLMSHSE || isHSEDesign || isMedia  ||
                        team?.moderationType == ModerationType.LMS}
                    {...((isExam || isCreativeCityUnit) && {
                        maxVisibleItems: isCreativeCityUnit ? 4 : 2,
                        isDropdown: true,
                    })}
                />
            )}
            {shouldDisplayShopLink && shopLink}
        </TeamTabsWrapper>
    )
}

export default TeamTabs;import { FlexBox } from "@brg/ui";
import { useBreakpoint, useIsMobile } from "@brg/ui";
import { SlideNavigation } from "shared/components/slideNavigation";
import { useCallback, useMemo } from "react";
import { LayoutConst } from "core/modules/layout.module";
import { SlideNavigationWrapperItemCustomLink } from "shared/pages/explore/styles";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { bProfile } from "core/utils/bProfile";
import { useProfile } from "@brg/auth";
import useQueryState from "shared/hooks/useQueryState";
import { AppTester } from "supporting";
import { useEncodedStateFilter } from "shared/components/Filters";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { DropdownTabs } from "./DropdownTabs";
import { TeamTabsWrapper } from "./styles";

const TeamTabs = ({
    team,
    tabList,
    tabColors,
    setCurrentTab,
    currentTab,
    contextTabs,
    tabIndex,
    titleIsTabs,
    isLoading,
    isContextWithoutTabs,
}: any) => {
    const {
        contextName: context,
        teamId,
        isShowEmployeesLink: contextHasEmployees,
        shouldVisibleMobileTabsOrTeamLink,
        isShopVisible,
        categories
    } = team;
    const profile = useProfile()
    const history = useHistory();
    const { t, i18n: { language } } = useTranslation();
    const theme = useTheme();
    const is992 = useBreakpoint(992);
    const is743 = useBreakpoint(743);
    const isMobile = useIsMobile();
    const [_, setQueryParams] = useQueryState();
    const { setSorting } = useEncodedStateFilter()

    const hasCategories = !!categories?.length;

    const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);

    const isMedia = AppTester.isMediiia() && !AppTester.isLectureMediiia();
    const isExam = AppTester.isExamHSE();
    const isLMSHSE = AppTester.isLMSHSE();
        const isHSEDesign = AppTester.isHSEDesign();
    const isCreativeCityUnit = useMemo(() => context === 'creativecityacademy', [context])

    const isGeograffee = AppTester.isGeograffee();
    const isDafes = AppTester.isGeoDafes();
    const isGameDeziiign = AppTester.isGameDeziiign();
    const isSuperPuper = AppTester.isSuperPuper();
    const isCGRAVE = AppTester.isCGRAVE();
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const isContiniumSite = AppTester.isContinuumSite();
    const isAcademy = AppTester.isAcademy();

    const isSuperPuperGames = useMemo(
        () => ((context  === 'superpupergames-mediiia'))
        , [context]);
    const shouldDisplayShopLink = useMemo(() => (isShopVisible), [isShopVisible, isModer]);
    const shouldShowDropdownTabs = isSuperPuperGames ? is743 : is992;

    const onShopClick = useCallback(() => {
        history.push(`/teams/${context || teamId}/shop`)
        return;
    }, [context])

    const shopLink = useMemo(() => shouldDisplayShopLink && (
        <SlideNavigationWrapperItemCustomLink
            style={{ marginLeft: (Object.keys(tabList).length > 0) ? 32 : 0, marginBottom: "0px" }}
            onClick={onShopClick}
            white_theme={false}
            active={false}>
            {t('nav.shop')}
            <svg
                className={'shop-link-svg'}
                width='16'
                height='14'
                viewBox='0 0 16 14'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    fill={theme.designerPage.slideLineInActive}
                    d='M12 10.7149H10.3329L10.3431 6.86984L5.21474 12L4 10.786L9.12833 5.65587H5.27573L5.2859 4H12V10.7149Z'
                />
            </svg>
        </SlideNavigationWrapperItemCustomLink>), [shouldDisplayShopLink, onShopClick, language, tabList, contextHasEmployees, shouldVisibleMobileTabsOrTeamLink])


    const tabsVisible = (
        (!isContextWithoutTabs && !(titleIsTabs && !hasCategories)) || shouldDisplayShopLink
    )
  
    if (shouldShowDropdownTabs) {
        return (
            <TeamTabsWrapper alignMobile='center' align={'center'} justify='flex-start' justifyMobile='flex-start' widthMobile={'100%'} width={'100%'}>
                {!isContextWithoutTabs && <DropdownTabs
                    //todo [МУСОР] брать из темы
                    whiteTheme={(isGeograffee && !isDafes || isGameDeziiign) || isSuperPuper || isCGRAVE || isAdcrDafesNet || isContiniumSite}
                    activeTabKey={currentTab}
                    // hasEmployees={contextHasEmployees}
                    // onTeamClick={onTeamClick}
                    displayShop={shouldDisplayShopLink}
                    onShopClick={shouldDisplayShopLink ? onShopClick : undefined}
                    mobileShrink={true}
                    activeText={(isAcademy || isSuperPuper) ? false : true}
                    isSuperPuperGames={isSuperPuperGames}
                    items={tabList}
                    onChange={(tab) => {
                        setCurrentTab(tab as string);
                        setQueryParams({ /*page: 1,*/ tab }, { replace: true });
                        sessionStorage.setItem('lastTab', tab)
                    }}
                />}
                {isContextWithoutTabs && shouldDisplayShopLink && shopLink}
            </TeamTabsWrapper>
        )
    }

    if (!tabsVisible) {
        return null;
    }

    return (
        <TeamTabsWrapper style={{ placeItems: 'center', position: 'relative' }} direction='row' className={'slide-navigation'}>
            {!isContextWithoutTabs && (
                <SlideNavigation
                    autoWidth={contextHasEmployees}
                    activeIndexKey={currentTab}
                    onChange={(tab) => {
                        if (isMedia) {
                            switch (tab) {
                                case 'popular':
                                    setSorting(2)
                                    break
                                case 'new':
                                    setSorting(1)
                                    break
                            }
                        }
                        setCurrentTab(tab as string);
                        // setQueryParams({ /*page: 1,*/ tab }, { replace: true });
                        sessionStorage.setItem('lastTab', tab)
                    }}
                    items={tabList}
                    colors={tabColors}
                    isLoading={isLoading}
                    capitalize={false}
                    // blueSelect={isMedia}
                    hoverPopup={!isMobile}
                    hoverContent={tabIndex}
                    hoverDataName={contextTabs}
                    isSuperPuperGames={isSuperPuperGames}
                    dropdownWhiteTheme={isExam || isLMSHSE || isHSEDesign || isMedia  ||
                        team?.moderationType == ModerationType.LMS}
                    {...((isExam || isCreativeCityUnit) && {
                        maxVisibleItems: isCreativeCityUnit ? 4 : 2,
                        isDropdown: true,
                    })}
                />
            )}
            {shouldDisplayShopLink && shopLink}
        </TeamTabsWrapper>
    )
}

export default TeamTabs;